import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	progressCircle: {
		minWidth: "65px",
		maxWidth: "65px",
	},
	centerText: {
		textAlign: "center",
	},
	progressGutter: {
		marginBottom: 3,
	},
}));

export default function AboutDialog({ setShowAbout }) {
	const classes = useStyles();

	const [open, setOpen] = React.useState(true);

	const handleClose = () => {
		setOpen(false);
		setShowAbout(false);
	};

	return (
		<div>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title" className={classes.centerText}>
					{"About Cessnock.Life"}
				</DialogTitle>
				<DialogContent className={classes.centerText}>
					<DialogContentText className={classes.centerText}>
						<strong>
							Cessnock.Life is a text-based simulation game taking place in
							Cessnock, NSW, Australia. You just need to click the AGE button
							and enjoy the ride.
						</strong>
					</DialogContentText>
					<DialogContentText id="alert-dialog-slide-description">
						{" "}
						Cessnock.Life is still being built and will change a lot. If you
						want to be informed when the finished version is available, you can
						join the notification list{" "}
						<a href="http://eepurl.com/hboMv1">here</a>.
					</DialogContentText>
					<DialogContentText id="alert-dialog-slide-description">
						{" "}
						Feedback can be emailed here: hey@cessnock.life
					</DialogContentText>
					<DialogContentText id="alert-dialog-slide-description">
						{" "}
						<em>Proudly built by a native Cessnockian.</em>
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary" variant="contained">
						OKAY{" "}
						<span role="img" aria-label="Thumbs up emoji">
							👍🏻
						</span>
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
